/**
 * JA (default in HTML) ↔ EN dictionary for [data-i18n] nodes.
 */
const STORAGE_KEY = "lixoris.lang";

const EN = {
  skip: "Skip to content",
  "nav.capabilities": "Services",
  "nav.process": "How we work",
  "nav.why": "Why us",
  "nav.company": "Company",
  "nav.contact": "Contact",
  "nav.cta": "Talk to us",
  "hero.eyebrow": "Enterprise AI / Cloud",
  "hero.h1a": "Engineering the Future",
  "hero.h1b": "with AI.",
  "hero.sub":
    "From enterprise AI and cloud projects to building your own solutions — we help clarify the problem, design, implement, and operate with a practical lens.",
  "hero.ctaPrimary": "Start with a consultation",
  "hero.ctaSecondary": "See what we offer",
  "hero.scroll": "Scroll",
  "triad.eyebrow": "Our foundation",
  "triad.lead":
    "Intelligence backed by reliable infrastructure, scaled without unnecessary complexity. These three axes guide every engagement.",
  "triad.1.t": "Intelligence",
  "triad.1.d": "AI and agents that reduce load in judgment, operations, and routine work.",
  "triad.2.t": "Infrastructure",
  "triad.2.d": "Cloud foundations you can operate — security, reproducibility, and cost included in the design.",
  "triad.3.t": "Scale",
  "triad.3.d": "Start small and grow smoothly as demand increases.",
  "cap.eyebrow": "Services",
  "cap.title": "What you can hire us for — projects or products",
  "cap.lead":
    "From work you want to outsource to solutions we build together. We aim for deliverables that hold up in production.",
  "cap.msp.t": "Ops / MSP AI agents",
  "cap.msp.d":
    "Alert triage, first-line ticketing, and routine ops automation — raise quality without adding headcount.",
  "cap.cloud.t": "Cloud optimization & recovery",
  "cap.cloud.d": "Cost visibility, guardrails, and recovery flows on AWS / Azure.",
  "cap.sap.t": "SAP integration & automation",
  "cap.sap.d": "Integrations, data sync, and automation for process-heavy workflows.",
  "cap.infra.t": "Infrastructure, IaC & migration",
  "cap.infra.d": "Reproducible platforms with Terraform and clear runbooks.",
  "cap.dev.t": "Custom development & prototypes",
  "cap.dev.d": "From early validation to production-grade delivery in short cycles.",
  "cap.saas.t": "Solution / SaaS development",
  "cap.saas.d": "Validation, design, build, and release — including productization paths.",
  "plat.eyebrow": "How we work",
  "plat.title": "A clear path from consultation to operations",
  "plat.lead":
    "No need to commit large upfront. We start by clarifying the problem, then design and build only what we agree on.",
  "plat.s1.t": "Discovery",
  "plat.s1.d": "Align on goals, constraints, and priorities — what to do and what not to do.",
  "plat.s2.t": "Design",
  "plat.s2.d": "Simple cloud / agent / data designs that include operating cost.",
  "plat.s3.t": "Build & validate",
  "plat.s3.d": "Ship something working early, then harden for production with docs.",
  "plat.s4.t": "Operate & improve",
  "plat.s4.d": "Monitoring, improvement loops, handoff, and optional ongoing support.",
  "why.eyebrow": "Why us",
  "why.title": "Progress over theater",
  "why.lead": "We do not dress up vanity metrics. We keep decisions and delivery moving.",
  "why.1.t": "Projects and products on the same foundation",
  "why.1.d": "Client work and in-house solutions both assume operable infrastructure.",
  "why.2.t": "Start small, avoid big misses",
  "why.2.d": "We begin with discovery and scope. We will not push expansion without clear value.",
  "why.3.t": "Boringly dependable technology",
  "why.3.d": "Prefer operability over hype — AWS / Azure, IaC, standard engineering practice.",
  "why.4.t": "Clear roles for people and agents",
  "why.4.d": "Automate what should be automated; keep human ownership where judgment matters.",
  "company.eyebrow": "Company",
  "company.title": "About Lixoris",
  "company.lead":
    "Lixoris is a solution studio for enterprise AI and cloud. We build systems that keep running after the demo ends.",
  "company.f1.l": "Name",
  "company.f1.v": "(リク・ソー・リス)",
  "company.f2.l": "Focus",
  "company.f2.v": "AI / cloud project support, solution & SaaS development, infrastructure & operations design",
  "company.f3.l": "Domains",
  "company.f3.v": "AWS, Azure, SAP-adjacent work, IaC, agent development",
  "company.f4.l": "Contact",
  "prin.eyebrow": "Principles",
  "prin.title": "What we will not compromise",
  "prin.lead": "Standards we hold when we take on work with you.",
  "prin.1.t": "Only what matters",
  "prin.1.d": "Impact × confidence ÷ effort. We start with high-leverage problems.",
  "prin.2.t": "Ruthless cost efficiency",
  "prin.2.d": "Prefer free / low-cost setups. Large spend only after agreement.",
  "prin.3.t": "Simple and robust",
  "prin.3.d": "Dependable technology choices. Operability first.",
  "prin.4.t": "Fast, not sloppy",
  "prin.4.d": "We use agents and automation for speed, and leave work that can be handed over.",
  "cta.eyebrow": "Contact",
  "cta.title": "Talk to us about a project or a build",
  "cta.lead": "“Can you help with this?” is enough to start. The first discovery call is free.",
  "contact.a1": "We usually reply within one business day",
  "contact.a2": "Happy to sign an NDA",
  "contact.a3": "The first discovery call is free",
  "contact.mailHint": "If the form does not work, email us at the address above.",
  "contact.name": "Name",
  "contact.email": "Email address",
  "contact.company": "Company",
  "contact.optional": "optional",
  "contact.message": "How can we help?",
  "contact.ph": "e.g. exploring ops automation on AWS, building an internal tool, etc.",
  "contact.send": "Send message",
  "contact.note": "We use your message only to respond to this inquiry. See Privacy for details.",
  "privacy.eyebrow": "Privacy",
  "privacy.title": "How we handle inquiry data",
  "privacy.p1":
    "Name, email, company, and message submitted via the form or email are used only to respond to your inquiry and related proposal or contracting communication.",
  "privacy.p2":
    "We do not share personal data with third parties without consent, except where required by law. When retention is no longer needed, we delete or anonymize the data within a reasonable period.",
  "privacy.p3": "Questions: hello@lixoris.com",
  "foot.blurb": "AI and cloud project support plus solution development — systems that keep working in the field.",
  "foot.c1": "Services",
  "foot.c1a": "AI agents",
  "foot.c1b": "Cloud & infrastructure",
  "foot.c1c": "SAP",
  "foot.c1d": "Solution development",
  "foot.c2": "Company",
  "foot.c2a": "How we work",
  "foot.c2b": "Why us",
  "foot.c2c": "About",
  "foot.c2d": "Privacy",
  "foot.c3": "Contact",
  "foot.c3b": "Get in touch",
  "foot.tag": "Intelligence × Infrastructure × Infinity",
};

const originals = new Map();
const originalPlaceholders = new Map();

function applyLang(lang) {
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (!key) return;
    if (!originals.has(el)) originals.set(el, el.innerHTML);
    if (lang === "en") {
      const text = EN[key];
      if (text !== undefined) el.textContent = text;
    } else {
      const html = originals.get(el);
      if (html !== undefined) el.innerHTML = html;
    }
  });

  document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
    const key = el.dataset.i18nPlaceholder;
    if (!key || !("placeholder" in el)) return;
    if (!originalPlaceholders.has(el)) originalPlaceholders.set(el, el.getAttribute("placeholder") || "");
    if (lang === "en") {
      const text = EN[key];
      if (text !== undefined) el.setAttribute("placeholder", text);
    } else {
      el.setAttribute("placeholder", originalPlaceholders.get(el) || "");
    }
  });

  // Privacy paragraphs (split keys keep markup simple)
  const privacyMap = [
    ["privacy.p1", 0],
    ["privacy.p2", 1],
    ["privacy.p3", 2],
  ];
  const privacyRoot = document.querySelector(".privacy-body");
  if (privacyRoot) {
    const paras = privacyRoot.querySelectorAll("p");
    privacyMap.forEach(([key, idx]) => {
      const el = paras[idx];
      if (!el) return;
      if (!originals.has(el)) originals.set(el, el.innerHTML);
      if (lang === "en") {
        const text = EN[key];
        if (text !== undefined) {
          if (key === "privacy.p3") {
            el.innerHTML = `Questions: <a href="mailto:hello@lixoris.com">hello@lixoris.com</a>`;
          } else {
            el.textContent = text;
          }
        }
      } else {
        el.innerHTML = originals.get(el);
      }
    });
  }

  document.documentElement.lang = lang;
  const label = document.querySelector("[data-lang-label]");
  if (label) label.textContent = lang === "en" ? "日本語" : "EN";
  localStorage.setItem(STORAGE_KEY, lang);
}

function readStoredLang() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "en" || stored === "ja" ? stored : "ja";
}

export function initI18n() {
  let lang = readStoredLang();
  applyLang(lang);
  document.getElementById("lang-toggle")?.addEventListener("click", () => {
    lang = lang === "en" ? "ja" : "en";
    applyLang(lang);
  });
}
